import type { CSSProperties } from "react"
import type { CellState } from "./editorModel"

// The editor draws each state in the staff calendar's own palette (bookingCalendar.css), so a
// public cell here looks like a public slot there: the slot types' edges, the hatched unavailable,
// and the break's warmer hatch. Managed's red edge is the literal ScheduleHeader's key uses.

const UNAVAILABLE: CSSProperties = {
  background: "repeating-linear-gradient(-45deg, var(--slot-unavail) 0 3px, var(--slot-unavail-stripe) 3px 6px)",
  border: "1px solid var(--slot-unavail-border)",
  color: "var(--slot-unavail-text)",
}

const OPEN: CSSProperties = {
  background: "var(--slot-open)",
  border: "1px solid var(--slot-open-border)",
  color: "var(--foreground)",
}

export const CELL_STYLE: Record<CellState, CSSProperties> = {
  unavailable: UNAVAILABLE,
  public: OPEN,
  private: {
    background: "var(--slot-private-open)",
    border: "1px solid var(--slot-open-border)",
    borderLeft: "3px solid var(--slot-private-edge)",
    color: "var(--slot-private-edge)",
  },
  managed: {
    background: "var(--slot-offslot-open)",
    border: "1px solid var(--slot-open-border)",
    borderLeft: "3px solid #dc2626",
    color: "#b91c1c",
  },
  available: { ...OPEN, borderLeft: "3px solid var(--staff-4)" },
}

/** A locked break: always unavailable, never editable. */
export const BREAK_STYLE: CSSProperties = {
  background: "repeating-linear-gradient(-45deg, var(--slot-break) 0 3px, var(--slot-break-stripe) 3px 6px)",
  border: "1px solid var(--slot-break-border)",
  color: "var(--slot-break-text)",
}
